// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote_quote__lt6eI","person":"quote_person__UAjrb","company":"quote_company__IpnAy"};